import React, { Component } from "react";
import { utils } from '../../helpers';
import { withTranslation } from 'react-i18next';
import { 
    Card, 
    CardHeader, 
    CardTitle,
    CardBody, 
    Input  
  } from "reactstrap";
  import Select from "react-select";
  import moment from 'moment';
  import Datetime from "react-datetime";
  import DiscreteValues from "../../constants/slider.constants";
  import Nouislider from "react-nouislider";
  import WeeklyChart from "./WeeklyChart";
  import ButtonWithTooltip from '../../components/Custom/ButtonWithTooltip';
  import ErrorModal from "../Components/ErrorModal"
  import SweetAlert from "react-bootstrap-sweetalert";
  import ReactTable from "react-table";
  import { loopbackService } from '../../services';
  import "moment/locale/it";
  
  import { roleConstants } from '../../constants';
  import User from '../../entities/User';

  const DayFormat = "DD/MM";

class WeeklyProfile extends Component {

    constructor(props) {
        super( props );


        let locale = "";
        let user = JSON.parse(localStorage.getItem('user'));
        if (user) {
          locale = user.language;
        }
    

        this.dailyProfileOptions = [];
        props.dailyProfiles.map(( dailyProfile )=>{
          this.dailyProfileOptions.push({
            label: dailyProfile.label,
            value: dailyProfile.id
          });
        });

        this.state = {
            errors: [],
            alert: null,
            isEditingProfile: props.isEditingProfile,
            editingProfile: props.editingProfile,
            dailyProfiles: props.dailyProfiles,
            saving: false,
            validationError: null,
            locale
        };
          


    }  
    
    componentWillReceiveProps(nextProps){
        this.setState(nextProps)
    }


    render() {
        
        let { selectedProfile, t, handleCancelProfile } = this.props;
        let { isEditingProfile, editingProfile, errors, saving } = this.state;

        const user = User.current();
        const isGuest = (user.userRoleId == roleConstants.GUEST);

        let fields = {
            label: "",
            validFrom: ""
        };
        
        if (isEditingProfile){
            if (editingProfile!=null){
              fields = {
                label: editingProfile.label,
                validFrom: ( editingProfile.validFrom !== null ? editingProfile.validFrom : "" )
              };    
            }

        } 
        else if (selectedProfile!==null){
          fields = {
            label: selectedProfile.label,
            validFrom: ( selectedProfile.validFrom !== null ? selectedProfile.validFrom : "" )
          };
        } 

        return (

            <Card className="center">
            
            <CardHeader className="main-wrapper">
              <CardTitle>
                
                { errors && errors.length>0 && <ErrorModal error={errors} onClickHandler={ () => { this.setState({ errors: [] }) }} /> }                
                              <div className="form-name">
                                    <Input 
                                      name = "label"
                                      type = "text" 
                                      value = { fields.label } 
                                      disabled = { !isEditingProfile }
                                      onChange = { (e) => {
                                          const { name, value } = e.target;
                                          editingProfile[name] = value;
                                          this.setState({ editingProfile });
                                      }}
                                      onKeyPress={(e) => {
                                        if (e.key === "Enter") {
                                            this.saveProfile();
                                        }
                                      }}
                                    /> 
  


                      

                    


                    <div className="form-actions">
  
                    { !isEditingProfile && 
                      <ButtonWithTooltip
                        id = "profile_edit"
                        color = "warning"
                        tooltipText={t("Modifica")}
                        size = "sm"
                        disabled={isGuest}
                        onClick={() => { 
                          this.setState({ 
                            isEditingProfile: true,
                            editingProfile: JSON.parse(JSON.stringify(selectedProfile))
                          })}}
                          ><i className="fa fa-edit" />
                      </ButtonWithTooltip>
                    }
                    { !isEditingProfile && 
                      <ButtonWithTooltip
                        id = "profile_delete"
                        color = "danger"
                        size = "sm"
                        disabled={isGuest}
                        tooltipText={t("Elimina")}
                        onClick={() => { this.confirmDeleteProfile(); }}
                      >
                        <i className="fa fa-trash" />
                        </ButtonWithTooltip>                
                    }
  
                    { isEditingProfile && 
                        <ButtonWithTooltip
                          id = "profile_save"
                          color = "success"
                          size = "sm"
                          disabled = { saving }
                          tooltipText={t("Salva")}
                          onClick={() => {
                            this.saveProfile();
                          }}
                        >
                          { !saving && <i className="fa fa-check" /> }
                          { saving && <i className="fa fa-refresh fa-spin" /> }
                          </ButtonWithTooltip>                
                    }
                    { isEditingProfile && 
                        <ButtonWithTooltip
                          id = "profile_cancel"
                          color = "default"
                          size = "sm"
                          tooltipText={t("Annulla")}
                          onClick={() => { 
                            handleCancelProfile();
                          }}
                        >
                          <i className="fa fa-times" />
                          </ButtonWithTooltip>                              
                    }
  
                  </div>
              </div>
            </CardTitle>
          </CardHeader>
        <CardBody className="full-height-map no-padding">
            { this.state.alert }
            { this.renderRelations() }
        </CardBody>
      </Card>
      );        
    }    








  /**
   */
  renderRelations(){

    const { t, selectedProfile } = this.props;

    const { editingProfile, isEditingProfile, dailyProfiles } = this.state;
    
    let relations = [];

    if (editingProfile===null && selectedProfile===null)
      return null;

    let profile = isEditingProfile ? editingProfile : selectedProfile;
    
    let els = [
      { key: "monFriProfileId", label: t("Lunedi - Venerdi") },
      { key: "satProfileId", label: t("Sabato") },
      { key: "sunProfileId", label: t("Domenica") },
    ] 

    els.map((el)=>{
      relations.push({
        label: el.label,
        key: el.key,
        profileId: profile[el.key]
      });
    });

    return (
      <div className="details-wrapper">

        <div style={ {width: "100%", height: "350px"} } >
          <WeeklyChart 
                relations = { relations }
                dailyProfiles = { dailyProfiles }
          />
        </div>

        <Card className="card-transitions">

          <CardHeader className="config-card-header">
            <CardTitle className="config-card-title" >
              <span style={{ flex: 1 }}>{t("Profili giornalieri collegati")}</span>
            </CardTitle>
          </CardHeader>
          
          <CardBody>
            
          <ReactTable
            data = { relations }
            className="-striped -highlight configurations"
            pageSize = { relations && relations.length }
            showPagination = {false}
            
            NoDataComponent = {() => null}
            columns = {[
              {
                Header: t("Giorni"),
                accessor: "label",
                filterable: false,
                Cell: (row) => {
                    return (<div className="no-overflow" align="">{ row.value }</div>)
                }

            },
            {
              Header: t("Profilo giornaliero"),
              accessor: "profileId",
              filterable: false,
              Cell: (row) => {
                
                const selectedOption = utils.getSelectedOption(this.dailyProfileOptions, row.value);
                
                if (isEditingProfile) {
                  return (
                    <Select
                      closeOnSelect = { true } 
                      placeholder = { t("Profilo") }
                      name = "profileId"
                      value = { selectedOption }
                      options = { this.dailyProfileOptions }
                      onChange = { option => {
                            editingProfile[row.original.key] = option ? option.value : 0;
                            this.setState({ editingProfile });
                      }}
                    />
                  );
                } else {
                  return (<div className="no-overflow" >{ selectedOption && selectedOption.label }</div>);
                }

              }





            }
           ]}
           

        />
      </CardBody>
    </Card>
    

      </div>
    );
  }



  async saveProfile(){
  

    let { handleSavedProfile, t } = this.props;
    let { editingProfile  } = this.state;

    if (editingProfile.monFriProfileId==0 || editingProfile.satProfileId==0 || editingProfile.sunProfileId==0 ){
          this.setState({
            alert: (
              <SweetAlert
                warning
                customClass="custom-sweet-alert"
                style={{ display: "block" }}
                title={ t("Impossibile salvare") } 
                onConfirm={() => {
                  this.setState({
                    alert: null
                  });      
                }}
                confirmBtnBsStyle = "info"
                confirmBtnText = {t("OK")}
              >
                {t("Specificare tutti i profili giornalieri")}
                </SweetAlert>
            )
          });
    }

    else {
        try {
              this.setState({ saving: true });
              let savedProfile = await loopbackService.edit('plant','timerprofileweekly',editingProfile);
              handleSavedProfile(savedProfile);
              this.setState({
                isEditingProfile: false,
                editingProfile: null,
                saving: false
              });
        } catch( error ){
            this.setState({ errors: [error], saving: false });
        }
      }
  }


    confirmDeleteProfile(){

        const { t } = this.props;
        const { model, selectedProfile } = this.state;
    
        if(!selectedProfile){
          return;
        }
    
        this.setState({
          alert: (
            <SweetAlert
              warning
              customClass="custom-sweet-alert"
              style={{ display: "block" }}
              title={ t("Elimina")+" "+selectedProfile.label } 
              onConfirm={() => {
                this.deleteProfile();
                this.setState({
                  alert: null
                });
    
              }}
              onCancel={() => {
                this.setState({
                  alert: null
                });
              }}
              confirmBtnBsStyle = "info"
              cancelBtnBsStyle = "danger"
              confirmBtnText = {t("SI")}
              cancelBtnText = {t("NO")}
              showCancel
            >
              {t("Sei sicuro?")}
              </SweetAlert>
          )
        });
      }
    


    
    
      async deleteProfile(){
        let { selectedProfile, handleDeletedProfile, t } = this.props;
        try {

            // verificare prima che il profilo non sia associato ad alcuna zona
            const result = await loopbackService.get("plant", "timerprofileweekly", selectedProfile.id,{ include: ['zones']});
            if (result.zones && result.zones.length>0){

              this.setState({
                alert: (
                  <SweetAlert
                    warning
                    customClass="custom-sweet-alert"
                    style={{ display: "block" }}
                    title={ t("Impossibile eliminare il profilo") } 
                    onConfirm={() => {
                      this.setState({
                        alert: null
                      });          
                    }}
                    confirmBtnBsStyle = "info"
                    cancelBtnBsStyle = "danger"
                    confirmBtnText = {t("OK")}
                  >
                    {t("E' assegnato alla zona ")+result.zones[0].label}
                    </SweetAlert>
                )
              });
            }
            else {
              await loopbackService.delete("plant", "timerprofileweekly", selectedProfile.id);
              handleDeletedProfile();
            }
        } catch(error){
            this.setState({
              errors: [error]
            })
        }
    }
  
  


}

export default WeeklyProfile = withTranslation()(WeeklyProfile);


// WEBPACK FOOTER //
// ./src/views/TimerProfiles/WeeklyProfile.jsx